import { Box, Tabs, Tab } from "@mui/material";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabWithCount } from "../SocialCase/SocialCase";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import { useEffect, useState } from "react";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import AvailableRefund from "../../components/RefundTabs/AvailableRefund";
import TransferTab from "../../components/RefundTabs/TransferTab";
import RefundDetails from "../../components/RefundTabs/refundDetails";
import VerifyAndPay from "../../components/MoveOutTerminationTabs/VerifyAndPay";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";

import User from "../../stores/UserStore";
// import General from '../../stores/GeneralStore';
import RefundAndTransfer from "../../stores/RefundAndTransferStore";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import { useNavigate } from "react-router-dom";
import { toJS } from "mobx";
import RefundThanks from "./RefundThanks";
import { Modal, Typography } from "@mui/material";
import ConfirmModal from "./ConfirmModal";
// import CashPayout from "../../components/RefundTabs/CashPayout";

type BankDetails = {
  customerName: any;
  bankAccountNumber: any;
  ibanNumber: any;
  swiftCode: any;
  bankBranchName: any;
  bankType: any;
  bankName: any;
  country: any;
  action: any;
  otherBankName?: any;
};

const Refund = () => {
  // let bankDetails = {};
  const navigate = useNavigate();

  const [value, setValue] = useState<any>(0);
  const [confirmation, setConfirmation] = useState<any>(false);
  const [title, setTitle] = useState<string | null>(null);
  const [bankDetails, setBankDetails] = useState<any>()
  const [referenceId, setReferenceId] = useState<string | null>(null);
  const [accParent, setacParent] = useState<any>([]);
  const [destinationAccount, setDestinationAccount] = useState<any>([]);
  const [ischanged, setIschanged] = useState(false);
  const [cashPayoutResponse,setCashPayoutResponse] = useState<any>([]);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [transfer, setTransfer] = useState(true);
  const [showCashRefund, setShowCashRefund] = useState(false);

  const handleTransfer = () => {
    if (accParent?.length == 0 && !ischanged) {
      if (RefundAndTransfer.negativeAccounts?.acctList) {
        RefundAndTransfer.negativeAccounts?.acctList.map(
          (account: any, index: any) => {
            RefundAndTransfer.addSelectedAccounts(
              RefundAndTransfer.negativeAccounts?.acctList[index]
            );
          }
        );
      }
    }
    setValue(value + 1);
    setTransfer(true);
  };
  const handleRefund = () => {
    if (accParent?.length == 0 && !ischanged) {
      if (RefundAndTransfer.negativeAccounts?.acctList) {
        RefundAndTransfer.negativeAccounts?.acctList.map(
          (account: any, index: any) => {
            RefundAndTransfer.addSelectedAccounts(
              RefundAndTransfer.negativeAccounts?.acctList[index]
            );
          }
        );
      }
    }
    setValue(value + 1);
    setTransfer(false);
  };
  const handleCashPayout = (response: any) => {
    console.log("This is response", response)
    if (response?.result.status == "SUCCESS") {
      setTransfer(true);
      setShowCashRefund(false)
      const [msg, ref] = response?.result?.statusMessage?.split('|');
      const message = General?.codeLabels["cm_msg_92000_1909"]?.label;
      const cleanedRef = message?.replace('%1', ref);
      setTitle(cleanedRef);
      setReferenceId(ref);
      setRefundLoader(false)
      setValue(value + 1);
      // setValue(2);
    } else if (response?.result.status == "FAIL") {
      setRefundLoader(false)

      setValue(0)
    }
    
  }
  const handleLoadAvailableAccounts = async () => {
    const personId = User.info.personId as string;
    await RefundAndTransfer.getNegativeAccountDetails({
      errorId: "getNegativeAccountDetailsError",
      data: personId,
    });

    await User.getBankData({ errorId: "getBankDataError", data: personId });
  };

  const handleLoadDestinationAccountsList = async () => {
    await RefundAndTransfer.getDestinationAccountsList({
      errorId: "getDestinationAccountsListError",
      data: User.info.personId as string,
    });
    const uniqueAccountIds = new Set(RefundAndTransfer?.selectedAccounts?.map(item => item.accountId));

    // Filter out elements from the second object with matching accountIds
    const filteredSecondObject = RefundAndTransfer?.destinationAccountsList?.filter(item => !uniqueAccountIds.has(item.accountId));

    console.log(filteredSecondObject);
    setDestinationAccount(filteredSecondObject);
  };
  const [transferLoader, setTransferLoader] = useState(false);
  const [refundLoader, setRefundLoader] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const handleOpenConfirmModal = (destAccountId: string) => {
    setSelectedAccount(destAccountId)
    setConfirmation(true);
  }
  const handleMakeTransfer = async () => {
    try {
      setTransferLoader(true);
      await RefundAndTransfer.makeTransfer({
        errorId: "makeTransferError",
        data: selectedAccount,
      });

      if (RefundAndTransfer.transferResponse.status == "S") {
        setTitle(General.codeLabels["cm_transfersuccess"].label);
        setReferenceId(
          RefundAndTransfer.transferResponse
            .cmTransferCreditBalanceOutputAdjustmentList[0].adjustmentId
        );
        setValue(2);
        setTransferLoader(false);
        setConfirmation(false)
      }
      setTransferLoader(false);
    } catch (error) {
      setTransferLoader(false);
      setConfirmation(false)

    }
  }
  useEffect(() => { }, [transfer])
  const handleMakeRefund = async () => {
    setRefundLoader(true);
    try {
      const res = await RefundAndTransfer.makeRefund({
        errorId: "makeRefundError",
        data: bankDetails,
      });
      if (res?.result.status == "SUCCESS") {
        setTransfer(true);
        const [msg, ref] = res?.result?.statusMessage?.split('|');
        const message = General?.codeLabels["cm_msg_92000_1909"]?.label;
        const cleanedRef = message?.replace('%1', ref);
        setTitle(cleanedRef);
        setReferenceId(ref);
        setRefundLoader(false)
        setValue(value + 1);
        // setValue(2);
      } else if (res?.result.status == "FAIL") {
        setRefundLoader(false)

        setValue(0)
      }
    } catch (error) {
      setRefundLoader(false)
      setValue(0)
    }
  };


  const handleSetBankDetails = (bDetails: any, edit: any) => {
    setShowCashRefund(false)
    const bankDetailsdata = {
      ...bDetails,
    };
    setBankDetails(bankDetailsdata)
    if (edit) {
      setValue(value - 1);
      RefundAndTransfer?.emptySelectedAccounts();
      setIschanged(false)
      setacParent([])
    } else {
      setValue(2)
    }


  };

  useEffect(() => {
    General.incrementServiceUsage('8')
    RefundAndTransfer?.emptySelectedAccounts()
  }, [])
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const cashRefund = (value: boolean) => {
    setShowCashRefund(value);
    if (value) {
      setValue((prevValue : any) => prevValue + 2);

    }
    // setValue((prevValue : any) => prevValue + 1);
  };

  return (
    <div style={{ backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : '' }}>
      <MoveInHeader
        style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff',
          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : ColorAss === '#101E8E' ? '#62aa51' : General?.ColorAss
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss === '#101E8E' ? '#62aa51' : General?.ColorAss,
                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: '0'
              }}
              onClick={() => navigate('/dashboard', { state: { fromRefund: true } })}
            >
              {General?.codeLabels["cm_backbutton"]?.label !== undefined ? General?.codeLabels["cm_backbutton"]?.label : "Back"}
            </ButtonSecondary>
            <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss === '#101E8E' ? '#62aa51' : General?.ColorAss,
                width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0"
              }}
              onClick={() => navigate("/dashboard")}
            >
              {General?.codeLabels["cm_dashboard"]?.label !== undefined ? General?.codeLabels["cm_dashboard"]?.label : "DASHBOARD"}
            </ButtonSecondary>
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: General?.isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          >
            {General?.codeLabels["cm_refundbalancetransfer"]?.label}
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer style={{ backgroundColor: contrast?.contrastBackground ? contrast?.contrastBackground : '#fff', width: General?.isLargeScreen ? "" : "100%" }}>
        <Box
          sx={{
            width: General?.isLargeScreen ? "80%" : "100%",
            marginTop: "46px",
          }}
        >

          <Box
            sx={{
              display: "flex",
              justifyContent: General?.isLargeScreen ? '' : "center"
            }}
          >
            <Tabs
              value={value}
              onChange={() => { }}
              aria-label="basic tabs example"
              sx={{ alignSelf: "flex-end", width: { md: '70%', lg: '100%' }, zIndex: "0" }}
              variant="scrollable"
              // scrollButtons
              allowScrollButtonsMobile
            >
              <Tab
                label={
                  <TabWithCount value={value} count={1}>
                    {General?.isLargeScreen && <span
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: General.contrast.contrastColor ? General.contrast.contrastBackground : ColorAss
                      }}
                    >
                      {General?.codeLabels["cm_available_fund"]?.label !== undefined ? General?.codeLabels["cm_available_fund"]?.label : "Available Refund"}
                    </span>}
                  </TabWithCount>
                }
                className="mui-move-in"
                {...a11yProps(0)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 1 ? false : true}

              />
              <Tab
                label={
                  <TabWithCount value={value} count={2}>
                    {General?.isLargeScreen && <span
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: General.contrast.contrastColor ? General.contrast.contrastBackground : ColorAss
                      }}
                    >
                      {General?.codeLabels["cm_fund_detail"]?.label !== undefined ? General?.codeLabels["cm_fund_detail"]?.label : "Transfer / Refund Details"}
                    </span>}
                  </TabWithCount>
                }
                className="mui-move-in"
                {...a11yProps(1)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  zIndex: "0",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 2 ? false : true}

              />
              <Tab
                label={
                  <TabWithCount value={value} count={3}>
                    {General?.isLargeScreen && <span
                      style={{
                        fontSize: `${General.accessibility.fontSize}rem`,
                        color: General.contrast.contrastColor ? General.contrast.contrastBackground : ColorAss
                      }}
                    >
                      {General?.codeLabels["cm_verify_confirm"]?.label !== undefined ? General?.codeLabels["cm_verify_confirm"]?.label : "Verify / Confirm"}
                    </span>}
                  </TabWithCount>
                }
                // className="mui-move-in"
                {...a11yProps(2)}
                sx={{
                  background: General?.isLargeScreen ? contrast?.contrastColor ? contrast?.contrastColor : "#e7e9f8" : "",
                  color: contrast?.contrastBackground ? contrast?.contrastBackground : "#101e8e",
                  margin: "0.2rem",
                  marginBottom: "0",
                  width: "32.5%",
                  "&.Mui-selected": {
                    outline: "none",
                  },
                }}
                disabled={value == 3 ? false : true}

              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
           <AvailableRefund
              totalAmount={RefundAndTransfer.negativeAccounts?.totalAmount}
              Next={handleRefund}
              Previous={handleTransfer}
              setacParent={setacParent}
              availableAccounts={RefundAndTransfer.negativeAccounts?.acctList}
              loadAvailableAccounts={handleLoadAvailableAccounts}
              addAccount={RefundAndTransfer.addSelectedAccounts}
              setIschanged={setIschanged}
              removeAccount={RefundAndTransfer.removeSelectedAccounts}
              cashRefund={cashRefund}
            /> 
            
            
          </TabPanel>

            <TabPanel value={value} index={1}>
            {transfer ? (
              <TransferTab
                selectedAccounts={RefundAndTransfer.selectedAccounts}
                Next={() => setValue(value + 1)}
                Previous={() => {
                  setValue(value - 1);
                  RefundAndTransfer?.emptySelectedAccounts()
                  setIschanged(false)
                  setacParent([])
                }}
                // destinationAccounts={RefundAndTransfer.destinationAccountsList}
                destinationAccounts={destinationAccount}
                loadDestinationAccountsList={handleLoadDestinationAccountsList}
                makeTransfer={handleOpenConfirmModal}
                transferLoader={transferLoader}
              />
            ) : (
              <RefundDetails
                bankData={User.bankData}
                makeRefund={handleSetBankDetails}
                Previous={() => {
                  setValue(value - 1);
                  RefundAndTransfer?.emptySelectedAccounts();
                  setIschanged(false)
                  setacParent([])
                }}
                selectedAccounts={RefundAndTransfer.selectedAccounts}
                refundLoader={refundLoader}
              />
            )}
            </TabPanel>

          <TabPanel value={value} index={2}>
            {showCashRefund ? (
              <VerifyAndPay
                refund={true}
                cashPayout={true}
              premiseId={RefundAndTransfer.negativeAccounts?.premiseId}
              email={User.profile.email as string}
              mobile={User.profile.mobileNumber as string}
              personID={User.info.personId as string}
              isModal={false}
              Previous={() => setValue(value - 2)}
                onVerify={handleCashPayout}
                // handleCashPayout = {setCashPayoutResponse}
                
              />
            ) : transfer ? (
              <RefundThanks
              referenceId={referenceId}
              title={title}
              serviceID={10}
              />
            ) : (
              <VerifyAndPay
              refund={true}
              premiseId={RefundAndTransfer.negativeAccounts?.premiseId}
              email={User.profile.email as string}
              mobile={User.profile.mobileNumber as string}
              personID={User.info.personId as string}
              isModal={false}
              Previous={() => setValue(value - 1)}
              onVerify={handleMakeRefund}
              />
            )}
          </TabPanel>
          <TabPanel value={value} index={3}>
          
              <RefundThanks
              referenceId={referenceId}
              title={title}
              serviceID={10}
              />
          </TabPanel>
        </Box>
      </ComplaintContainer>
      <Modal
        open={confirmation}
        onClose={() => setConfirmation(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <ConfirmModal
          onClose={() => {
            setConfirmation(false)
            setValue(0)
            RefundAndTransfer?.emptySelectedAccounts();
            setIschanged(false)
            setacParent([])
          }}
          loader={transferLoader}
          onConfirm={handleMakeTransfer}
        />
      </Modal>
    </div>
  );
};

export default observer(Refund);
